<template>
  <div id="app" tabindex="-1">
    <span
      style="font-style: italic; visibility: hidden; position: absolute"
      aria-hidden="true"
      >Novartis</span
    >

    <transition name="fade">
      <WelcomeDisclaimer
        v-if="
          cookies.get('isHcp') === 'false' || cookies.isKey('isHcp') === false
        "
      />
    </transition>

    <transition name="fade">
      <CookieDisclaimer
        v-if="
          cookies.get('acceptCookies') === 'false' ||
            cookies.isKey('acceptCookies') === false
        "
      />
    </transition>

    <LegalDisclaimer />

    <AppHeader :showMenuButton="$router.currentRoute.name !== 'welcome'" />

    <router-view class="page" />

    <RelatedContent>
      <template #related-content>
        <ul>
          <li @click="launchTactic(tactics.diagnostic)">
            <img
              class="thumbnail"
              src="@/assets/img/thumbnail-placeholder.png"
              alt=""
            />
            <img
              src="@/assets/img/icon-pdf-black.svg"
              alt="Experience will launch in a new tab"
            />
            Insights Into MS: Diagnostic Challenges
          </li>

          <li @click="launchTactic(tactics.neuroinflammation)">
            <img
              class="thumbnail"
              src="@/assets/img/thumbnail-video-neuroinflammation.png"
              alt=""
            />
            <img
              src="@/assets/img/icon-video-black.svg"
              alt="Experience will launch in a new tab"
            />
            From Neuroinflammation to Neurodegeneration in MS (6:51)
          </li>
        </ul>
      </template>
    </RelatedContent>

    <AppFooter
      :showReferences="$router.currentRoute.name !== 'welcome'"
      jobCode="388555-2"
      :showTerms="true"
    />

    <transition name="fade">
      <BtnTop
        v-show="showTopButton && $router.currentRoute.name !== 'welcome'"
      />
    </transition>
  </div>
</template>

<script>
import WelcomeDisclaimer from "@/components/novartis/WelcomeDisclaimer.vue";
import RelatedContent from "@/components/novartis/RelatedContent.vue";

export default {
  name: "App",
  components: {
    WelcomeDisclaimer,
    RelatedContent,
  },
  provide() {
    return {
      goToOverview: this.goToOverview,
      gotoRoute: this.gotoRoute,
    };
  },
  data() {
    return {
      scrollTop: 0,
      prevScroll: 0,
      state: this.$store.state,
      cookies: this.$cookies,
      scrollTicks: 0,
      tactics: {
        diagnostic: {
          title: "Diagnostic Challenges",
          urlDev: "/diagnosis/diagnostic-challenges/pdf",
          // urlDev:"https://nov-20364-dev-cac-inv.azurewebsites.net/#/diagnostic-challenges",
          urlProd: "/diagnosis/diagnostic-challenges/pdf",
          analyticsLabel: "Neuroinflammation: diagnostic-challenges",
        },
        neuroinflammation: {
          title: "From Neuroinflammation to Neurodegeneration in MS",
          urlDev:
            "/mechanism-of-disease/neuroinflammation-neurodegeneration/video",
          urlProd:
            "/mechanism-of-disease/neuroinflammation-neurodegeneration/video",
          analyticsLabel:
            "Neuroinflammation: From Neuroinflammation to Neurodegeneration in MS",
        },
      },
    };
  },
  watch: {
    $route() {
      document.getElementById("app").focus();
    },
  },
  computed: {
    isIE() {
      let ua = window.navigator.userAgent;
      let msie = ua.indexOf("MSIE ");

      if (msie > 0 || navigator.appVersion.indexOf("Trident/") > -1) {
        // IE11 check
        return true;
      } else if (document.documentMode || /Edge/.test(navigator.userAgent)) {
        // Edge check
        return true;
      }

      // Return false for all other browsers
      return false;
    },
    showTopButton() {
      if (this.prevScroll > this.scrollTop) {
        return this.scrollTop > window.innerHeight / 2;
      } else {
        return false;
      }
    },
  },
  mounted() {
    let body = document.body;
    // Reset scroll position on first launch
    body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    window.addEventListener("scroll", this.scrollHandler);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollHandler);
  },
  methods: {
    updateScrollTop() {
      // Add fallback as scrollTop property varies by browser.
      if (this.isIE) {
        this.scrollTicks++;
        if (this.scrollTicks % 3 === 0) {
          this.gainScrollValues();
        }
      } else {
        this.gainScrollValues();
      }
    },
    gainScrollValues() {
      this.prevScroll = this.scrollTop;
      this.scrollTop = window.scrollY || window.pageYOffset;
    },
    scrollHandler() {
      this.updateScrollTop();
    },
    launchTactic: function(tactic) {
      this.$gtag.event("click", {
        event_category: "launch_page",
        event_label: tactic.analyticsLabel,
      });

      let url =
        process.env.NODE_ENV === "development" ? tactic.urlDev : tactic.urlProd;

      if (tactic.route) {
        this.$router.push({ name: tactic.route });
      } else {
        window.open(url, "_self");
      }
    },
    goToOverview: function() {
      // Set questions after topic has been selected!

      // QuizPlugin.setQuestions();
      // switch (this.$store.state.currentTopic) {
      //   case "topic1":
      //     this.$router.push({ name: "early-diagnosis" });
      //     break;
      //   case "topic2":
      //     this.$router.push({ name: "early-intervention" });
      //     break;
      //   case "topic3":
      //     this.$router.push({ name: "high-efficacy-treatment" });
      //     break;
      //   case "topic4":
      //     this.$router.push({ name: "biomarkers" });
      //     break;
      //   case "topic5":
      //     this.$router.push({ name: "referral-timing-and-pathways" });
      //     break;
      //   case "topic6":
      //     this.$router.push({ name: "holistic-patient-care" });
      //     break;
      //   case "topic7":
      //     this.$router.push({ name: "covid-19" });
      //     break;
      //   case "topic8":
      //     this.$router.push({ name: "immunoglobulins" });
      //     break;
      //   default:
      //     this.$router.push({ name: "home" });
      // }

      this.$gtag.event("click", {
        event_category: "go_to_overview",
        event_label: "continue",
      });
    },
    gotoRoute(routeValue) {
      switch (routeValue) {
        case "early-diagnosis":
          this.$store.setTopic("topic1");
          break;
        case "early-intervention":
          this.$store.setTopic("topic2");
          break;
        case "high-efficacy-treatment":
          this.$store.setTopic("topic3");
          break;
        case "biomarkers":
          this.$store.setTopic("topic4");
          break;
        case "referral-timing-and-pathways":
          this.$store.setTopic("topic5");
          break;
        case "holistic-patient-care":
          this.$store.setTopic("topic6");
          break;
        case "covid-19":
          this.$store.setTopic("topic7");
          break;
        case "immunoglobulins":
          this.$store.setTopic("topic8");
          break;
        default:
          this.$store.setTopic("");
      }
      this.goToOverview();
    },
  },
};
</script>

<style lang="scss">
@import "@/scss/styles";

body {
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #dadada;
  // min-width: 1024px;

  &.no-scroll {
    overflow: hidden;
  }

  // @include breakpoint(xs) {
  //   min-width: 332px;
  // }

  // @include breakpoint(sm) {
  //   min-width: 375px;
  // }

  // @include breakpoint(md) {
  //   min-width: 667px;
  // }
}

cite,
em,
i {
  font-style: italic;
}

button,
a,
input,
label,
video,
video::-webkit-media-controls-timeline,
video::-webkit-media-controls-panel,
video::-webkit-media-controls-play-button,
video::-webkit-media-controls-fullscreen-button,
video::-webkit-media-controls-volume-slider,
video::-webkit-media-controls-mute-button {
  &:focus {
    outline: 4px solid #ffd086;
  }
}

button:-moz-focusring,
[type="button"]:-moz-focusring,
[type="reset"]:-moz-focusring,
[type="submit"]:-moz-focusring {
  outline: 4px solid#FFD086;
}

video:-moz-focusring {
  outline: 4px solid#FFD086;
}

a:-moz-focusring {
  outline: 4px solid#FFD086;
}

#app {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
  font-family: "Volta Modern Text Web", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $black;
  font-size: rem(16px);
  position: relative;

  &:focus,
  &:active {
    outline: none;
  }

  &.no-scroll {
    overflow: hidden;
  }
}

.page {
  flex: 1 0 auto;
}

.flex-container {
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}

.bottom-border {
  padding-bottom: rem(20px);
  position: relative;

  &:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    height: 3px;
    width: 90px;
    background: $white;
  }
}

.btn-cta {
  border: 2px solid $white;
  color: $white;
  background: none;
  padding: rem(20px);
  width: rem(350px);
  display: block;
}

.btn-back {
  border: 1px solid $blue-dark;
  color: $blue-dark;
  background: none;
  padding: rem(20px);
  display: block;
}

// Transitions
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.app-header {
  a {
    color: black;
  }
  a:visited {
    color: black;
  }
}

.inner-content {
  height: 100%;
  width: 100%;
  // margin: 0 auto;
  max-width: 1024px;
  text-align: left;
  padding: rem(25px);
  z-index: 1;

  // @media (min-width: 1680px) {
  //   max-width: 1400px !important;
  // }
}

footer {
  color: black;
  .inner-content {
    max-width: 1024px;
  }
}
</style>
